import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext.tsx';
import { CustomSSOLogin } from '@/components/CustomSSOLogin.tsx';

export function LoginPage() {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // If already authenticated, redirect to saved destination or home
    if (isAuthenticated && !isLoading) {
      const savedUrl = sessionStorage.getItem('wellspring:redirect_after_login');
      if (savedUrl) {
        sessionStorage.removeItem('wellspring:redirect_after_login');
        navigate(savedUrl, { replace: true });
      } else {
        navigate('/');
      }
    }
  }, [isAuthenticated, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className='flex items-center justify-center min-h-screen'>
        <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-primary'></div>
      </div>
    );
  }

  // Show the custom SSO login component
  return <CustomSSOLogin />;
}
